export default {
  methods: {
    async getUserIdentity(uid){
      try {
        const res = await axios.get(`api/v1/userInfo/${uid}/getIdentityInfo`);
        return res.data.identity;
      }
      catch (e) {
        return null;
      }
    },
    async getUserIdentityStatus(uid){
      let identity = await this.getUserIdentity(uid);
      let status = 0;
      if(identity !== null){
        this.status = 0;
        status = identity.identity_status;
      }
      return status;
    },
    shouldRunMatiProcess(status){
      return status === 0 || status === 4 || status === 5 || status === null;
    },
    matiIsPending(status){
      return status === 0 || status === null;
    },
    matiIsRunning(status){
      return status === 3 || status === 2;
    },
    verificationIsCompleted(status){
      return status === 1;
    },
    verificationIsRejected(status){
      return status === 4;
    },
    verificationIsInProcess(status){
      return status === 3;
    },
    verificationisNewRequired(status){
      return status === 5;
    },
    verificationIsReviewNeeded(status){
      return status === 2;
    },
    handleIdentityStatus(identityStatus, needsText = false) {
      let text = "La identidad del solicitante no ha sido verificada. No se puede aprobar este proyecto.";
      if(identityStatus == 2 || identityStatus == 3) {
        text = "El proceso de metamap aún está corriendo";
      } else if (identityStatus == 0 || identityStatus == null) {
        text = "El proceso de metamap aún está pendiente de realizar por el solicitante.";
      } else if (identityStatus == 4) {
        text = "Metamap ha rechazado la verificación de identidad del solicitante.";
      } else if (identityStatus == 5) {
        text = "Es necesario que el solicitante realice otra vez el proceso de verificación de identidad con Metamap.";
      } else if (identityStatus == 1) {
        text = "La identidad del solicitante ha sido verificada con éxito.";
      }
      if(needsText) {
        return text;
      } else {
        this.missingFieldsNotif("Estado de Metamap",text);
      }
    },
    getStatusStr($option)
    {
       let $statusStr = "No definido";
       switch ($option) {
          case 1:
             $statusStr = "Verificada";
             break;
          case 2:
             $statusStr = "Revisión necesaria";
             break;
          case 3:
             $statusStr = "En proceso";
             break;
          case 4:
             $statusStr = "Rechazada";
             break;
          case 5:
             $statusStr = "Reintentar";
             break;
          case 6:
             $statusStr = "Datos no coinciden";
             break;
          default:
             break;
       }
       return $statusStr;
    }
  }
}